export enum TicketState {
    new = 1,
    open = 2,
    pending_reminder = 3,
    closed = 4,
    merged = 5,
    pending_close = 6,
}

export const ticketStateLabels: Record<TicketState, string> = {
  [TicketState.new]: 'New',
  [TicketState.open]: 'Open',
  [TicketState.pending_reminder]: 'Pending reminder',
  [TicketState.closed]: 'Closed',
  [TicketState.merged]: 'Merged',
  [TicketState.pending_close]: 'Pending close',
}

/**
 * Получает название состояния по его числовому значению
 * @param state Числовое значение состояния тикета
 * @returns Название состояния или undefined, если не найдено
 */
export function getTicketStateLabelByValue(state: number): string | undefined {
  return ticketStateLabels[state as TicketState]
}

/**
 * Получает числовое значение состояния по его названию
 * @param label Название состояния тикета
 * @returns Числовое значение состояния или undefined, если не найдено
 */
export function getTicketStateValueByLabel(label: string): number | undefined {
  const entry = Object.entries(ticketStateLabels).find(([_, value]) => value === label)
  return entry ? Number(entry[0]) : undefined
}

/**
 * Проверяет, существует ли состояние с указанным числовым значением
 * @param state Числовое значение состояния
 * @returns true, если состояние существует, иначе false
 */
export function isValidTicketState(state: number): boolean {
  return Object.values(TicketState).includes(state)
} 